'use es6';

import { applyAxesProperties } from './axesProperties';
import { applySlicedColors, applyXYColors } from './colors';
import { applyCustomSeries } from './customSeries';
import { applyHideDataLabels } from './hideDataLabels';
import { applyXYHideLegend } from './hideLegend';
import { applyXYHideMarkers } from './hideMarkers';
import { applyIncludeDateLine } from './includeDateLine';
import { applyLegendPosition } from './legendPosition';
import { applyOnlyLegend } from './onlyLegend';
import { applySeriesOrder } from './seriesOrder';
import { applyShowTotals } from './showTotals';
import { applyStacked } from './stacked';
import { applyTooltipDisabled } from './tooltipDisabled';
export const applyXYDisplayParams = (visualization, report, brandKitPalettes) => {
  return visualization.update(viz => applyHideDataLabels(viz, report)).update(viz => applyXYHideMarkers(viz, report)).update(viz => applyXYHideLegend(viz, report)).update(viz => applyXYColors(viz, report, brandKitPalettes)).update(viz => applyAxesProperties(viz, report)).update(viz => applySeriesOrder(viz, report)).update(viz => applyIncludeDateLine(viz, report)).update(viz => applyStacked(viz, report)).update(viz => applyOnlyLegend(viz, report)).update(viz => applyLegendPosition(viz, report)).update(viz => applyCustomSeries(viz, report)).update(viz => applyTooltipDisabled(viz, report));
};
export const applySlicedDisplayParams = (visualization, report, brandKitPalettes) => {
  return visualization.update(viz => applySlicedColors(viz, report, brandKitPalettes)).update(viz => applyHideDataLabels(viz, report)).update(viz => applyLegendPosition(viz, report)).update(viz => applyShowTotals(viz, report)).update(viz => applyTooltipDisabled(viz, report));
};